/** Payment requests whose failure leaves the shopper unable to pay or to see a paid order confirmed. */
export const PAYMENT_ENDPOINTS = {
  stripePaymentIntent: '/payment/stripe/paymentIntent',
  paypalOrderRecovery: '/paypal/orders/recovery',
} as const;
